import { render, staticRenderFns } from "./MissionColor.vue?vue&type=template&id=31c3f24e"
import script from "./MissionColor.vue?vue&type=script&lang=js"
export * from "./MissionColor.vue?vue&type=script&lang=js"
import style0 from "./MissionColor.vue?vue&type=style&index=0&id=31c3f24e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports